import api from '../plugins/api';

// LocalStorage key
const APP_CONSTANTS_STORAGE_KEY = 'app_constants';
const LAST_FETCH_DATE_KEY = 'app_constants_last_fetch';

// Kullanıcı girişi kontrolü
const isUserLoggedIn = () => {
  return !!localStorage.getItem('access_token');
};

/**
 * API'den sabit değerleri çeker ve localStorage'a kaydeder
 * @returns {Promise<Object>} Sabit değerler
 */
export const fetchAppConstants = async () => {
  // Giriş yapılmamışsa boş dön
  if (!isUserLoggedIn()) {
    return {};
  }

  try {
    const response = await api.get('/generic/app-constants');
    const constants = response.data;
    
    // Verileri localStorage'a kaydet
    localStorage.setItem(APP_CONSTANTS_STORAGE_KEY, JSON.stringify(constants));
    // Son çekme tarihini kaydet (şu anki tarih)
    localStorage.setItem(LAST_FETCH_DATE_KEY, new Date().toISOString().split('T')[0]);
    
    return constants;
  } catch (error) {
    console.error('Sabit değerler çekilemedi:', error);
    // Eğer localStorage'da kayıtlı veri varsa, onu kullan
    const storedConstants = localStorage.getItem(APP_CONSTANTS_STORAGE_KEY);
    return storedConstants ? JSON.parse(storedConstants) : {};
  }
};

/**
 * Sabitleri localStorage'dan alır veya gerekirse API'den çeker
 * @returns {Promise<Object>} Sabit değerler
 */
export const getAppConstants = async () => {
  // Giriş yapılmamışsa boş dön
  if (!isUserLoggedIn()) {
    return {};
  }

  // Son çekme tarihini kontrol et
  const lastFetchDate = localStorage.getItem(LAST_FETCH_DATE_KEY);
  const today = new Date().toISOString().split('T')[0];
  
  // localStorage'da kayıtlı sabitleri al
  const storedConstants = localStorage.getItem(APP_CONSTANTS_STORAGE_KEY);
  
  // Eğer veri varsa ve bugün çekilmişse, var olan verileri kullan
  if (storedConstants && lastFetchDate === today) {
    return JSON.parse(storedConstants);
  }
  
  // Veri yoksa veya bugün çekilmemişse, API'den çek
  return await fetchAppConstants();
};

/**
 * Belirli bir kategoriden sabit değeri döndürür
 * @param {string} category - Kategori adı (CUSTOMERS, ACL_ROLES, vb.)
 * @param {string} key - Sabit adı (CUSTOMER_ETHICA_SIGORTA, ROLE_SUPER_ADMIN, vb.)
 * @returns {string|null} Sabit değeri veya null
 */
export const getConstantId = (category, key) => {
  // Giriş yapılmamışsa null dön
  if (!isUserLoggedIn()) {
    return null;
  }

  try {
    const constants = JSON.parse(localStorage.getItem(APP_CONSTANTS_STORAGE_KEY) || '{}');
    return constants[category]?.[key] || null;
  } catch (error) {
    console.error('Sabit değer okunamadı:', error);
    return null;
  }
};

// Tüm sabit kategorilerini ve değerlerini içeren nesne
const constants = {
  CUSTOMERS: {
    CUSTOMER_ETHICA_SIGORTA: () => getConstantId('CUSTOMERS', 'CUSTOMER_ETHICA_SIGORTA'),
    CUSTOMER_ACN_TURK_SIGORTA: () => getConstantId('CUSTOMERS', 'CUSTOMER_ACN_TURK_SIGORTA'),
    CUSTOMER_GIG_SIGORTA: () => getConstantId('CUSTOMERS', 'CUSTOMER_GIG_SIGORTA')
  },
  ACL_ROLES: {
    ROLE_SUPER_ADMIN: () => getConstantId('ACL_ROLES', 'ROLE_SUPER_ADMIN')
  },
  MEDIA_TYPES: {
    MEDIA_TYPE_DAMAGE_PHOTO: () => getConstantId('MEDIA_TYPES', 'MEDIA_TYPE_DAMAGE_PHOTO')
  },
  CAR_DAMAGE_CLAIM_TYPES: {
    INSURANCE_TYPE_CASCO: () => getConstantId('CAR_DAMAGE_CLAIM_TYPES', 'INSURANCE_TYPE_CASCO')
  },
  VIDEO_CALL_PROVIDER: {
    VIDEO_CALL_DEFAULT_AGENDA: () => getConstantId('VIDEO_CALL_PROVIDER', 'VIDEO_CALL_DEFAULT_AGENDA')
  }
};

export default constants; 
